export default {
  PROHIBITED_FILE_TYPE: 'prohibited_file_type',
  UPLOAD_FILE_CANCELED: 1,
  UPSELL_INTERRUPTION_CANCELLED: 2,
};
